import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { FloppyDisk, Cpu, ShareNetwork, Trash } from '@phosphor-icons/react';

export default function ProfileList({ profiles, loadProfile, deleteProfile, shareProfile }) {
    if (profiles.length === 0) {
        return (
            <Card className="glass-card text-center py-12">
                <FloppyDisk size={48} className="text-muted-foreground mx-auto mb-3" />
                <p className="text-muted-foreground">No saved profiles</p>
            </Card>
        );
    }

    return (
        <div className="space-y-2">
            {profiles.map(p => (
                <Card key={p.profile_id} className="glass-card">
                    <CardContent className="p-3 flex items-center gap-3">
                        <div className="w-10 h-10 rounded-xl bg-cyber-purple/10 flex items-center justify-center shrink-0">
                            <Cpu size={18} className="text-cyber-purple" />
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className="text-sm font-bold truncate">{p.name}</p>
                            <p className="text-[10px] text-muted-foreground">{p.controller_brand} {p.controller_model}</p>
                        </div>
                        <div className="flex gap-1">
                            <Button size="sm" variant="ghost" className="text-xs text-primary" onClick={() => loadProfile(p)} data-testid={`load-profile-${p.profile_id}`}>Load</Button>
                            <Button size="sm" variant="ghost" className="text-xs" onClick={() => shareProfile(p.profile_id)}><ShareNetwork size={14} /></Button>
                            <Button size="sm" variant="ghost" className="text-xs text-destructive" onClick={() => deleteProfile(p.profile_id)}><Trash size={14} /></Button>
                        </div>
                    </CardContent>
                </Card>
            ))}
        </div>
    );
}
